import { createRoot } from 'react-dom/client';
import NextApp from './NextApp';
import registerServiceWorker from './registerServiceWorker';

// Wrap the rendering in a function:
function Render() {
  return <NextApp />;
}
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Render />);

// Do this once
registerServiceWorker();
